<template>
    <table-generic
    class="signatures-table"
    :class="{ mobile: isMobile }"
    :headerData="!isMobile ? tableHeaderData : mobileTableHeaderData"
    :tableStyles="tableStyles"
    :tableData="!isMobile ? signatureListMapping : mobileSignatureListMapping"
    :hasDetail="false"/>
</template>

<script setup>
import TableGeneric from '@/components/generic/table/Generic'

/* Vue */
import { computed } from 'vue'

/* Aux */
import { getDate } from '@/assets/scripts/dateBuilders'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props
@signatureList {Array} - array with oparation signatures
@isMobile {Boolean}
*/
const props = defineProps({
    signatureList: Array,
    isMobile: Boolean
})

/*************************************************
*                                                *
*                     Table                      *
*                                                *
*************************************************/
const tableHeaderData = [
    { label: t('approvals.signed.modal.details.signatures.tableHeaders.entity'), rowCellType: 'description' },
    { label: t('approvals.signed.modal.details.signatures.tableHeaders.weight'), rowCellType: 'description' },
    { label: t('approvals.signed.modal.details.signatures.tableHeaders.status'), rowCellType: 'status', dataAttr: 'status' }
]

const mobileTableHeaderData = [
    {
        label: '',
        rowCellType: 'title',
        showInMobile: { groupWith: ['statusDescription'] }
    },
    {
        label: '',
        rowCellType: 'description',
        dataAttr: 'statusDescription'
    },
    { label: '', rowCellType: 'status', dataAttr: 'status', showInMobile: true }
]

const tableStyles = [
    null,
    { width: '130px', 'min-width': '130px' },
    props.isMobile ? null : { width: '130px', 'min-width': '130px' }
]

/* Map for table */
const signatureListMapping = computed(() => {
    return props.signatureList.map((signature, index) => ([
        { value: index, dataAttr: 'id' },
        { type: 'title', value: signature.name, dataAttr: 'description' },
        { type: 'description', value: `${signature.weight}%`, dataAttr: 'description' },
        {
            type: 'status',
            value: {
                text: signature.signDate ? t('approvals.signed.modal.details.signatures.signed') : t('approvals.signed.modal.details.signatures.notSigned'),
                icon: signature.signDate ? 'check-circle' : 'clock',
                classes: [signature.signDate ? 'positive' : 'warning', 'capitalize']
            },
            dataAttr: 'status'
        }
    ]))
})

/* Map for mobile table */
const mobileSignatureListMapping = computed(() => {
    return props.signatureList.map((signature, index) => ([
        { value: index, dataAttr: 'id' },
        { type: 'title', value: signature.name, dataAttr: 'description' },
        {
            type: 'description',
            value: {
                content: signature.signDate ? `${getDate(signature.signDate)} - ${signature.channel}` : t('approvals.signed.modal.details.signatures.notSigned'),
                classes: [signature.signDate ? 'positive' : 'warning', 'capitalize']
            },
            dataAttr: 'statusDescription'
        },
        {
            type: 'status',
            value: {
                icon: signature.signDate ? 'check-circle' : 'clock',
                classes: signature.signDate ? 'positive' : 'warning'
            },
            dataAttr: 'status'
        }
    ]))
})
</script>

<style lang="scss" scoped>
.signatures-table {
    padding-bottom: 24px;

    :deep(.table-header-cell):first-of-type,
    :deep(.cell-wrapper):first-of-type {
        padding-left: 24px;
    }

    &.mobile {
        padding-bottom: 0;
    }
}
</style>
